// extracted by mini-css-extract-plugin
export default {"nowrap":"DifficultQuestionsTable_nowrap__81Pf5"};